import {useMemo} from "react";

import {useTranslation} from "react-i18next";

export const useLanguages = () => {
  const {t} = useTranslation();

  const LANGUAGES = useMemo(() => {
    return [
      {id: 0, name: t("language.en"), value: "en"},
      {id: 1, name: t("language.ru"), value: "ru"},
    ];
  }, [t]);

  return {LANGUAGES};
};
